import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import UploadModules from "../../constants/uploadModules";
import testimonialService from "../../services/testimonial/testimonialService";
import "./Testimonial.css";

export default function TestimonialForm() {
    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        customerName: "",

        companyName: "",

        designation: "",

        photo: "",

        testimonial: "",

        rating: 5,

        displayOrder: 0,

        isActive: true

    });

    useEffect(() => {

        if (isEdit) {

            loadTestimonial();

        }

    }, []);

    const loadTestimonial = async () => {

        try {

            setLoading(true);

            const response = await testimonialService.getById(id);
            const data = response.data;

            console.log("Image Path:", data.photo);
            if (response.success) {

                const data = response.data;

                setForm({

                    customerName: data.customerName || "",

                    companyName: data.companyName || "",

                    designation: data.designation || "",

                    photo: data.photo || "",

                    testimonial: data.testimonial || "",

                    rating: data.rating || 5,

                    displayOrder: data.displayOrder || 0,

                    isActive: data.isActive

                });

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.customerName.trim()) {

            toast.error("Customer Name is required.");

            return;

        }

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await testimonialService.update(id, form);

            }
            else {

                response = await testimonialService.create(form);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/testimonials");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit Testimonial" : "Add Testimonial"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">

                            <div className="col-md-6">

                                <label className="form-label">
                                    Customer Name <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="customerName"
                                    value={form.customerName}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-6">

                                <label className="form-label">
                                    Company Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="companyName"
                                    value={form.companyName}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-6">

                                <label className="form-label">
                                    Designation
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="designation"
                                    value={form.designation}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3">

                                <label className="form-label">
                                    Rating
                                </label>

                                <select
                                    className="form-select"
                                    name="rating"
                                    value={form.rating}
                                    onChange={handleChange}
                                >
                                    <option value="1">1 Star</option>
                                    <option value="2">2 Stars</option>
                                    <option value="3">3 Stars</option>
                                    <option value="4">4 Stars</option>
                                    <option value="5">5 Stars</option>
                                </select>

                            </div>

                            <div className="col-md-3">

                                <label className="form-label">
                                    Display Order
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-12">

                                <label className="form-label">
                                    Photo
                                </label>

                                <ImageUploader
                                    module={UploadModules.TESTIMONIAL}
                                    value={form.photo}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            photo: path
                                        })
                                    }
                                />

                            </div>

                            <div className="col-12">

                                <label className="form-label">
                                    Testimonial
                                </label>

                                <textarea
                                    rows="5"
                                    className="form-control"
                                    name="testimonial"
                                    value={form.testimonial}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-12">

                                <div className="form-check">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/testimonials")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}